require('./kovButton.scss');

let m = angular.module('kovButtonModule', []);
m.component('kovButton', require('./kovButton.js')); 
m.component('kovJumboButton', require('./kovJumboButton'));

module.exports = 'kovButtonModule';